import { render, staticRenderFns } from "./BannerContainer.vue?vue&type=template&id=2004c82f"
import script from "./BannerContainer.vue?vue&type=script&lang=ts"
export * from "./BannerContainer.vue?vue&type=script&lang=ts"
import style0 from "./BannerContainer.vue?vue&type=style&index=0&id=2004c82f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports